import globals from '../../../globals';
import { _sendWithAxios, _sendWithAxiosBlob } from '../../api'

const REACT_APP_URL_BASE_API = globals.REACT_APP_URL_BASE_API;

export const cadastrarUsuarioAdmin = async (data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}User/cadastrar-adminstrador/`, 'POST', data)
}

export const listarUsuarioAdmin = async (page) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}User/listar-usuarios-admin/${page}/10`, 'GET')
}

export const listarUsuarioAdminComFiltro = async (filtro, page) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}User/listar-usuarios-admin-filtrado/${filtro}/${page}/10`, 'GET')
}

export const atualizarUsuarioAdmin = async (data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}User/atualizar-administrador/`, 'PUT', data)
}

export const detalheUsuarioAdmin = async (idUsuarioAdmin) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}User/detalhe-usuario-admin/${idUsuarioAdmin}`, 'GET')
}

export const inativarUsuarioAdmin = async (idUsuario) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}User/inativar-usuario/${idUsuario}`, 'PUT')
}

export const ativarUsuario = async (idUsuario) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}User/ativar-usuario/${idUsuario}`, 'PUT')
}

export const gerarRelatorioUsuariosAdmin = async () => {
    return await _sendWithAxiosBlob(`${REACT_APP_URL_BASE_API}User/extrair-usuarios-administradores/`, 'GET')
}
